import { defaultSettings, type AppSettings } from '../types';

const KEY = 'graphite.settings.v1';
const LEGACY_VOICE_ENDPOINT = 'https://app.journeyup.ru/api/voice';

function loadVoiceEndpoint(saved: Record<string, unknown>) {
  const endpoint = String(saved.voiceEndpoint || defaultSettings.voiceEndpoint).replace(/\/$/, '');
  return endpoint === LEGACY_VOICE_ENDPOINT ? defaultSettings.voiceEndpoint : endpoint;
}

export function loadSettings(): AppSettings {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || '{}') as Record<string, unknown>;
    return {
      ...defaultSettings,
      cloudEndpoint: String(saved.cloudEndpoint || saved.authEndpoint || saved.syncEndpoint || saved.dataEndpoint || defaultSettings.cloudEndpoint),
      configEndpoint: String(saved.configEndpoint || defaultSettings.configEndpoint),
      voiceEndpoint: loadVoiceEndpoint(saved),
      embeddingsEndpoint: String(saved.embeddingsEndpoint || defaultSettings.embeddingsEndpoint),
      llmEndpoint: String(saved.llmEndpoint || defaultSettings.llmEndpoint),
      serviceToken: String(saved.serviceToken || defaultSettings.serviceToken),
      userId: Number(saved.userId || defaultSettings.userId),
      userKey: String(saved.userKey || defaultSettings.userKey),
      userName: String(saved.userName || defaultSettings.userName),
    };
  } catch {
    return defaultSettings;
  }
}

export function saveSettings(settings: AppSettings) {
  localStorage.setItem(KEY, JSON.stringify(settings));
}
